<template id="custom-echarts">
    <div class="status-echart" :id="'status-echart'+index" :style="'width:'+width+';'+'height:'+height+';'"></div>
</template>

<script>
    import Vue from 'vue';
    import echarts from 'echarts';
    export default ({
    /*
    * index: 图标ID，避免绘图时冲突
    * curData: 当前图标数据
    * chartData: 所有图标数据，用于遍历
    * */
        props: ['index','option','width','height'],
        data() {
        return {

            }
        },
        mounted() {
            this.init();
        },
        // 销毁子组件后重建，避免第一个数据不更新的问题
        destroyed() {
            // this.$parent.showChart = true;
        },
        methods: {
            init(){
                let echartID = 'status-echart'+this.index;
                // 基于准备好的dom，初始化echarts实例
                let myChart = echarts.init(document.getElementById(echartID));
                // 指定图表的配置项和数据
                let option = this.option;

                // 使用刚指定的配置项和数据显示图表。
                myChart.setOption(option);
            }
        }
    })
</script>

<style scoped>
@media screen and (-webkit-max-width: 1366px) and (-webkit-min-width: 1024px),(max-width:1366px) and (min-width:1024px){
    #status-echart542{
        width:250px!important;
    }
}
</style>



// WEBPACK FOOTER //
// echart.vue?75ef5255